// src/components/Navbar.jsx
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaSun, FaMoon } from "react-icons/fa";
import { CartContext } from "../context/CartContext";
import { SearchContext } from "../context/SearchContext";
import { useTheme } from "../context/ThemeContext";
import "./Navbar.css";

const Navbar = ({
  isDetailPage = false,
  productTitle = "",
  onShare = null
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminPage = location.pathname.startsWith("/admin");

  const { cart } = React.useContext(CartContext);
  const { searchQuery, setSearchQuery } = React.useContext(SearchContext);
  const { isDarkMode, toggleTheme } = useTheme();

  // Detail Page Layout
  if (isDetailPage) {
    return (
      <nav className="navbar navbar-detail">
        <div className="navbar-container">
          {/* Home Button */}
          <button
            className="back-button"
            onClick={() => navigate('/')}
            aria-label="Go to Home"
            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            <span className="back-text">Home</span>
          </button>

          {/* Logo */}
          <div className="product-title-wrapper">
            <Link to="/" className="navbar-brand" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src="/jollybaba-logo.png" alt="JollyBaba" style={{height: '28px', objectFit: 'contain'}} />
            </Link>
          </div>

          {/* Right Actions */}
          <div className="navbar-actions detail-actions">
            {/* Theme Toggle */}
            <button
              className="icon-button theme-toggle-btn"
              onClick={toggleTheme}
              aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
            >
              {isDarkMode ? <FaSun /> : <FaMoon />}
            </button>

            {/* Share Button */}
            {onShare && (
              <button
                className="icon-button share-nav-btn"
                onClick={onShare}
                aria-label="Share product"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="18" cy="5" r="3" />
                  <circle cx="6" cy="12" r="3" />
                  <circle cx="18" cy="19" r="3" />
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                </svg>
              </button>
            )}

            {/* Cart */}
            <Link to="/cart" className="icon-button cart-button">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
              {cart.length > 0 && <span className="cart-badge">{cart.length}</span>}
            </Link>
          </div>
        </div>
      </nav>
    );
  }

  // Default Layout
  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Image Logo */}
        <Link to="/" className="navbar-brand" onClick={() => navigate("/")} style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/jollybaba-logo.png" alt="JollyBaba" style={{height: '36px', objectFit: 'contain'}} />
        </Link>

        {/* Center - Search Bar (Desktop) */}
        {!isAdminPage && (
          <div className="navbar-search-wrapper">
            <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input
              type="text"
              className="navbar-search"
              placeholder="Search mobiles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        )}

        {/* Right Side Actions */}
        <div className="navbar-actions">
          {/* Theme Toggle */}
          <button
            className="theme-toggle-navbar"
            onClick={toggleTheme}
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {isDarkMode ? <FaSun /> : <FaMoon />}
          </button>

          {!isAdminPage && (
            <Link to="/cart" className="cart-button">
              <svg className="cart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
              {cart.length > 0 && <span className="cart-badge">{cart.length}</span>}
            </Link>
          )}

        </div>
      </div>
    </nav>
  );
};

export default Navbar;
